import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Info } from 'lucide-react';

const PATHS = [
  '/', '/kypa', '/kypa/directory', '/faq', '/blog', '/kya', '/manifesto', '/mcp', '/how-a-dispute-works',
  '/vs/experian-agent-trust', '/three-analysts-one-gap', '/seven-conditions', '/adl-m', '/film/recourse',
  '/film/priya', '/for-merchants', '/for/merchants', '/for-b2b-procurement', '/for-issuers', '/for-underwriters',
  '/for-payments-platforms', '/for-banks', '/for/banks', '/resources', '/binding-gate',
];

const matches = (path) => PATHS.includes(path) || path.startsWith('/kypa/agent/');

export const RecourseDisclaimer = () => {
  const { pathname } = useLocation();
  if (!matches(pathname.replace(/\/$/, '') || '/')) return null;
  return (
    <aside className="bg-[#050505] border-t border-white/10 px-6 py-6" data-testid="recourse-disclaimer">
      <div className="container mx-auto max-w-6xl flex gap-3 text-xs text-gray-500 leading-relaxed">
        <Info className="w-4 h-4 shrink-0 mt-0.5 text-gray-600" />
        <p>
          <span className="text-gray-300 font-semibold">Not insurance. No guarantee of recovery.</span> A KYPA pledge is a public commitment signal posted by the agent operator, not a promise of repayment to any party. Kojiru is not a fiduciary, custodian, adjudicator, or party to any transaction, and assumes no liability for any agent, operator, merchant, or counterparty action. Nothing on this site is legal, tax, or financial advice.{' '}
          <Link to="/terms" className="text-gray-300 underline hover:text-white" data-testid="recourse-disclaimer-terms">Terms</Link>{' . '}
          <Link to="/privacy" className="text-gray-300 underline hover:text-white" data-testid="recourse-disclaimer-privacy">Privacy</Link>
        </p>
      </div>
    </aside>
  );
};
